var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconWorkflow = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M5.7,18H2.9c-1,0-1.9-0.8-1.9-1.9V9.5 M18,9.4V2.9c0-1-0.8-1.9-1.9-1.9c0,0,0,0,0,0 H2.9C1.8,1,1,1.8,1,2.9v6.6" }),
            React.createElement("path", { d: "M29,21.2v6.1 c0,1-0.8,1.7-1.7,1.7H15.1c-1,0-1.7-0.8-1.7-1.7v-2.2 M29,21.2v-6.1c0-1-0.8-1.7-1.7-1.7c0,0,0,0,0,0H15.1c-1,0-1.7,0.8-1.7,1.7v2.2" }),
            React.createElement("path", { d: "M19.8,17.1l4,4l-4,4" }),
            React.createElement("path", { d: "M23.9,21.2l-12.5,0.1 c-1,0-1.9-0.8-1.9-1.9V9.5" }))));
});
export default IconWorkflow;
//# sourceMappingURL=IconWorkflow.js.map